module.exports = __webpack_public_path__ + "static/ro-workshops-7-81d04c546d59d81b98656aac3f7fabca.jpg";